import { z } from 'zod'
import {
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
} from '../shared/schema'

export const schema = z.object({
  roomId: z.string(),
  userId: z.string(),
  createdAt: nullSafeOptionalFirestoreTimestamp(),
  localScore: nullSafeOptionalNumber(),
  lmsScore: nullSafeOptionalNumber(),
  newScore: nullSafeOptionalNumber(),
})

export const writeSchema = schema

export type FirestoreLMSConflict = z.infer<typeof schema>
